import { useMutation } from "@tanstack/react-query";
import { postSignUpAction } from "../actions/postSignUp.action";
import { TFormValues } from "../../../../../components/Form/types/form.types";

export const usePostSignUp = () => {
    return useMutation({
        mutationFn: async (data: TFormValues) => await postSignUpAction(data),
        onSuccess: () => {
            console.log("User signed up successfully");
        },
        onError: (error) => {
            console.log("Oh no :(");
            console.log(error);
        }
    })
}